<template>
  <ProxyImg :img="data"></ProxyImg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import ProxyImg from './ProxyImg';
@Component({
  components: {
    ProxyImg,
  },
})
export default class StaticImage extends Vue {
  @Prop({ type: Array }) data!: string[];
}
</script>
